import {
    GetPDM_MA_ItemList,
    GetPDM_MA_ItemListByPage,
    GetPDM_MA_ItemEntity,
    CreatePDM_MA_ItemEntity,
    UpdatePDM_MA_ItemEntity,
    DeletePDM_MA_ItemEntity,
} from '@/api/pdm/ma/maItem'

import msg from '@/config/notify'
import dlg from '@/config/dialog'


export const PdmMaItem = {
    namespaced: true,
    state: {
        PdmMaItemList: [],
        PdmMaItemListLoading: false,
        PdmMaItemEntity: null,
        PdmMaItemShowDlg: false,
    },
    mutations: {
        setPdmMaItemList(state, dataList) {
            state.PdmMaItemList = [...dataList]
        },
        setPdmMaItemListLoading(state, visible) {
            state.PdmMaItemListLoading = visible
        },
        setPdmMaItemShowDlg(state, visible) {
            state.PdmMaItemShowDlg = visible
        },
        setPdmMaItemEntity(state, entity) {
            state.PdmMaItemEntity = entity
        },
    },
    actions: {
        //创建预约套餐对象
        actCreatePdmMaItem({ commit }, parm) {
            return new Promise((resolve, reject) => {
                CreatePDM_MA_ItemEntity(parm).then(res => {
                    if (res.Code == 0) {
                        res.Data.IsValid = 0;
                        commit('setPdmMaItemEntity', res.Data)
                        commit('setPdmMaItemShowDlg', true)
                        console.log(`output->res.Data`,res.Data)
                         //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        reject(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载预约套餐对象
        actGetPdmMaItemEntity({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmMaItemListLoading', true)
                GetPDM_MA_ItemEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaItemEntity', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmMaItemListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载预约套餐列表
        actGetPdmMaItemList({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmMaItemListLoading', true)
                GetPDM_MA_ItemList(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaItemList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmMaItemListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //分页加载预约套餐列表
        actGetPdmMaItemListByPage({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmMaItemListLoading', true)
                GetPDM_MA_ItemListByPage(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaItemList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                       // msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmMaItemListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //保存预约套餐信息
        actUpdatePdmMaItem({ commit,state }, parm) {
            return new Promise((resolve) => {
                UpdatePDM_MA_ItemEntity(parm).then(res => {
                    if (res.Code == 0) {
                        var temp  = [...state.PdmMaItemList]
                        const index = temp.findIndex(item => item.ItemID === res.Data.ItemID)
                        if (index > -1) {
                          // 如果已经存在该 ItemID 对应的数据，则进行更新操作
                          temp.splice(index, 1, res.Data)
                        } else {
                          // 否则进行插入操作
                          temp.push(res.Data)
                        }
                        commit('setPdmMaItemList', temp)
                        commit('setPdmMaItemShowDlg', false)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_MA_Item
        actEditPdmMaItemData({ commit }, entity) {
            return new Promise((resolve) => {
                let parm = {                    
                    ItemID : entity.ItemID
                }
                GetPDM_MA_ItemEntity(parm).then(res => {
                    if (res.Code == 0) {
                        // var info = {}
                        // Object.assign(info,state.getTableNameL3(TableName.Name)%>Entity)
                        // Object.assign(info,res.Data)
                        // commit('getTableNameL3(TableName.Name)%>Entity', info)
                        commit('setPdmMaItemEntity', res.Data)
                        commit('setPdmMaItemShowDlg', true)
                        // msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_MA_Item ,传对象过来
        actEditPdmMaItem({ commit }, entity) {
            return new Promise(() => {
                commit('setPdmMaItemEntity', entity)
                commit('setPdmMaItemShowDlg', true)
            }).catch(err => {
                console.log(err)
            })
        },
        //删除PDM_MA_Item
        actDeletePdmMaItem({ commit }, e) {
            return new Promise((resolve) => {
                dlg.confirm("是否确定要删除当前预约套餐？").onOk(() => {
                    DeletePDM_MA_ItemEntity(e).then(res => {
                        if (res.Code == 0) {
                            commit('setPdmMaItemShowDlg', false)
                           
                            msg.success("删除预约套餐成功。")
                            resolve(res)
                        } else {
                            dlg.alert("删除预约套餐失败，原因:" + res.Message)
                            //msg.success("删除预约套餐失败，原因:" + res.Message)
                            resolve(res)
                        }
                    })
                })
            }).catch(err => {
                console.log(err)
            })
        }
    }
}
